<template>
    <div class="p-4 bg-white shadow-md rounded-lg">
        <h3 class="text-lg font-semibold mb-2">Filter By Name</h3>
        <div class="flex items-center mb-2 w-full">
            <v-btn color="blue" @click="resetFilters" block small text>
                Reset Filters
            </v-btn>
        </div>
        <div class="flex items-center mb-2">
            <input type="checkbox" id="selectAll" v-model="selectAll" @change="onSelectAll" class="mr-2" />
            <label for="selectAll" class="text-sm">Select All</label>
        </div>
        <div class="flex items-center mb-2">
            <input type="checkbox" id="includeBlanks" v-model="includeBlanks" @change="onBlanksSelect" class="mr-2" />
            <label for="includeBlanks" class="text-sm">Blanks</label>
        </div>
        <div class="max-h-48 overflow-y-auto">
            <div v-for="name in nameList" :key="name" class="flex items-center mb-1">
                <input type="checkbox" :id="name" :value="name" v-model="selectedNames" @change="onNameSelect"
                    class="mr-2" />
                <label :for="name" class="text-sm">{{ name }}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nameList: [], // initializing it empty will populate it dynamically
            selectedNames: [],
            selectAll: false,
            includeBlanks: true, // New property for "Blanks" filter
        };
    },
    methods: {
        resetFilters() {
            // Reset the filter to default state
            this.selectedNames = [];
            this.selectAll = false;
            this.includeBlanks = true;

            // Inform ag-Grid about the filter changes on reset
            this.params.filterChangedCallback();
        },
        onSelectAll() {
            // If "Select All" is checked, select all names; otherwise, deselect all
            this.selectedNames = this.selectAll ? [...this.nameList] : [];
            this.includeBlanks = this.selectAll; // Sync with "Blanks" checkbox
            this.params.filterChangedCallback();
        },
        onBlanksSelect() {
            // Update "Select All" checkbox based on blanks checkbox
            this.selectAll = this.includeBlanks && this.selectedNames.length === this.nameList.length;
            this.params.filterChangedCallback();
        },
        onNameSelect() {
            // Update "Select All" checkbox status based on selection
            this.selectAll = this.selectedNames.length === this.nameList.length && this.includeBlanks;
            this.params.filterChangedCallback();
        },
        isFilterActive() {
            // Filter is active if any name is selected or "Blanks" is unchecked
            return this.selectedNames.length > 0 || !this.includeBlanks;
        },
        doesFilterPass(params) {
            const allColumns = this.params.columnApi.getAllColumns();
            const colIndex = allColumns.findIndex(column => column.getColId() === this.params.column.getColId());

            const cellValue = params.data.pams[colIndex - 1].name;
            const isCellEmpty = (cellValue === '' || cellValue === null || cellValue === undefined);

            if (this.selectedNames.length > 0) {
                if (this.includeBlanks == true) {
                    return this.selectedNames.includes(cellValue) || isCellEmpty;
                } else {
                    return this.selectedNames.includes(cellValue);
                }
            } else {
                if (this.includeBlanks == true) {
                    return true;
                } else {
                    return !isCellEmpty;
                }
            }

        },
        getModel() {
            // Returns the current filter state
            if (!this.isFilterActive()) {
                return null;
            }

            return {
                selectedNames: this.selectedNames,
                includeBlanks: this.includeBlanks,
            };
        },
        setModel(model) {
            // Sets the filter state based on the provided model
            this.selectedNames = model ? model.selectedNames : [];
            this.includeBlanks = model ? model.includeBlanks : true;
            this.selectAll = this.includeBlanks && this.selectedNames.length === this.nameList.length;
        },
        updateNameList() {
            const allColumns = this.params.columnApi.getAllColumns();
            const colIndex = allColumns.findIndex(column => column.getColId() === this.params.column.getColId());

            const uniqueNames = new Set();

            this.params.rowModel.forEachNode((node) => {
                const name = node.data.pams[colIndex - 1].name;
                if (name) uniqueNames.add(name);
            });

            this.nameList = Array.from(uniqueNames);
        }
    },
    mounted() {
        this.updateNameList();
    },
};
</script>

<style scoped>
/* Add any additional styles if necessary */
</style>